import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ElectronicSignatureRequest, {
	ElectronicSignatureParams,
} from './ElectronicSignatureRequest';

interface Props extends BaseModalProps {
	onSign: (values: ElectronicSignatureParams) => void;
	userId: string;
}

const ElectronicSignatureRequestModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.doElectronicSignature'>
			<ElectronicSignatureRequest onSign={props.onSign} userId={props.userId} />
		</BaseModal>
	);
};

export default ElectronicSignatureRequestModal;
